export class AuthError extends Error {
    public readonly authExists: boolean;
    public readonly wrongLoginMethod: boolean;

    constructor(
        message: string,
        {
            authExists = false,
            wrongLoginMethod = false,
        }: {
            authExists?: boolean;
            wrongLoginMethod?: boolean;
        },
    ) {
        super(message);

        this.name = "AuthError";
        this.authExists = authExists;
        this.wrongLoginMethod = wrongLoginMethod;
    }
}
